import { Card, Col, Row } from "react-bootstrap";
import OpacitySlider from "../opacitySlider/OpacitySlider";
import { mileageRanges } from "../../theme/mileageRanges";
import ToggleButtonProps from "../ToggleButton/ToggleButton";
import { useBoundaries } from "../../context/boundary";
import { useTheme } from "../../context/theme";

interface PercentageChangeRange {
  minValue?: number; // undefined = no lower bound
  maxValue?: number; // undefined = no upper bound
  color: string;
}

const Legend = () => {
  const { showLabels, setShowLabels } = useBoundaries();
  const { opacity, setOpacity } = useTheme();

  const formatLabel = (range: PercentageChangeRange) => {
    if (range.minValue === undefined) {
      return `< ${range.maxValue}%`;
    }
    if (range.maxValue === undefined) {
      return `≥ ${range.minValue}%`;
    }
    return `${range.minValue}% to ${range.maxValue}%`;
  };

  const setMileageOpacity = (opacity: number) => {
    document.documentElement.style.setProperty(
      "--mileage-opacity",
      opacity.toString(),
    );
    setOpacity(opacity);
  };

  return (
    <Card className="p-3">
      <div className="d-flex flex-column gap-2">
        {mileageRanges.map((range, idx) => (
          <Row key={idx} className="align-items-center">
            <Col xs={2}>
              <div
                style={{
                  backgroundColor: range.color,
                  height: "15px",
                  width: "15px",
                }}
              />
            </Col>

            <Col xs={10} className="text-start">
              <span className="text-sm">{formatLabel(range)}</span>
            </Col>
          </Row>
        ))}
      </div>
      <div className="d-flex align-items-center justify-content-center mt-3 mb-2">
        {" "}
        <span>Opacity</span>
      </div>
      <div>
        {" "}
        <OpacitySlider onChange={setMileageOpacity} value={opacity} />{" "}
      </div>{" "}
      <div className="d-flex align-items-center justify-content-center mt-3 mb-2">
        {" "}
        <span>Boundary Labels</span>
      </div>
      <div>
        {" "}
        <ToggleButtonProps
          options={[
            { label: "On", value: true },
            { label: "Off", value: false },
          ]}
          value={showLabels}
          onChange={(value: any) => setShowLabels(value)}
        />
      </div>{" "}
    </Card>
  );
};
export default Legend;
